var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTokenSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16841",
    transform: "translate(-532)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 596",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(532)",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 8.622 1.369-1.265A26.4 26.4 0 0 1 5.783 10a38.213 38.213 0 0 1 9.771-8.37L16 2.657c-3.426 2.989-5.935 6.319-9.547 12.8A68.634 68.634 0 0 0 0 8.622z",
    transform: "translate(540 7.367)",
    style: {
      fill: "#3d71ff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenSelected);
export default __webpack_public_path__ + "static/media/TokenSelected.4bf87c9b.svg";
export { ForwardRef as ReactComponent };